var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var TopicListItem = require('./topicListItem.jsx');

var TopicList = createReactClass({

    componentDidMount: function(){
        new Foundation.Accordion($(ReactDOM.findDOMNode(this)), {allowAllClosed: true});
    },

    render: function(){
        var TopicListItemNodes = this.props.topicList.map(function(topic, i){
            return <TopicListItem topic={topic} key={i} />;
        });

        return (
            <ul className="topic-list accordion no-bullet" data-accordion>
                {TopicListItemNodes}
            </ul>
        );
    }
});

module.exports = TopicList;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/layout/topicList.jsx